import React from 'react';
import {Box, Button, Chip, Stack, Typography} from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {useBoardInvitations, useCancelInvitation} from '../../data/invitations';

dayjs.extend(relativeTime);

// The board's invitations that haven't been answered yet, with a way to take one back. Shown to whoever manages the board.
export function PendingInvitations({boardId}: {boardId: string}) {
    const {data: invitations = []} = useBoardInvitations(boardId);
    const {mutate: cancel, isPending, variables: cancelling} = useCancelInvitation(boardId);

    if (invitations.length === 0) return null;

    return (
        <Box sx={{mt: 2}}>
            <Typography variant="subtitle2" component="h3" color="text.secondary" gutterBottom>
                Waiting for an answer
            </Typography>
            <Stack divider={<Box sx={{borderTop: 1, borderColor: 'divider'}}/>}>
                {invitations.map((invitation) => (
                    <Box key={invitation.id} sx={{display: 'flex', alignItems: 'center', gap: 1, py: 1}}>
                        <Box sx={{flex: 1, minWidth: 0}}>
                            <Typography variant="body2" noWrap>{invitation.email}</Typography>
                            <Typography variant="caption" color="text.secondary">
                                Invited {dayjs(invitation.createdAt).fromNow()}
                            </Typography>
                        </Box>
                        <Chip size="small" variant="outlined" label={`${invitation.role}${invitation.kiosk ? ' · kiosk' : ''}`}/>
                        <Button
                            size="small"
                            color="inherit"
                            disabled={isPending && cancelling === invitation.id}
                            onClick={() => cancel(invitation.id)}
                            aria-label={`Cancel the invitation to ${invitation.email}`}
                        >
                            Cancel
                        </Button>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
